@if (customerData) {
  <div class="dialogContainer">
    <div class="dialogHeader">
      <img class="closeDialogBtn" (click)="closeDialog()" />
    </div>
    <div class="dialogContent">
      <app-dialog-input-title
        title="Kunde navn"
        [required]="true"
      ></app-dialog-input-title>
      <input type="text" class="textbox" [(ngModel)]="customerData.name" />
    </div>
    <div class="dialogFooter">
      <app-save-button
        [disabled]="!customerData.name"
        [clickEvent]="saveChanges.bind(this)"
        >
      </app-save-button>
      @if (userService.getSelectedRole == userService.getUserRoleTypes.Admin) {
        <app-delete-button
          [clickEvent]="deleteCustomer.bind(this)"
          >
        </app-delete-button>
      }
    </div>
  </div>
}
